module.exports = __webpack_public_path__ + "static/el-obrero-internacional-1-183fe43f652197bffd6f7cf90b52b977.png";